/**
 * Maximum matrices per link, mirroring `@ArrayMaxSize(200)` on the `LinkMatricesToDirectoryDTO`.
 * Without the cap in the modal, "select all" with "Todos os registros" goes past 200 and the
 * backend rejects the whole batch with a 400, which reaches the user as the generic
 * "Erro ao adicionar Registro. Tente novamente" — a message that suggests retrying the same
 * action, which fails the same way.
 */
export const ADD_RECORD_MAX_SELECTIONS = 200;

export const ADD_RECORD_SELECTION_LIMIT_MESSAGE = `O número máximo de registros selecionados é ${ADD_RECORD_MAX_SELECTIONS}.`;
